(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bombox-personalizer"] && !Shopify.designMode) return;
  try {
    class BomboxPersonalizer extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.maxSide = Number(this.dataset.maxSide) || 1400;
      this.required = { cubo: this.dataset.cubo === 'true' ? 4 : 0, instax: this.dataset.instax === 'true' ? 10 : 0 };
      this.querySelectorAll('.bx-slot__input').forEach((input) => input.addEventListener('change', () => this.onPick(input)));
      this.querySelectorAll('.bx-slot__remove').forEach((btn) => btn.addEventListener('click', () => this.clearSlot(btn.closest('.bx-slot'))));
      const multi = this.querySelector('[data-multi]');
      if (multi) multi.addEventListener('change', () => this.onMulti(multi));
      const frase = this.querySelector('[data-frase]');
      if (frase) frase.addEventListener('input', () => this.updateChars(frase));
      const cube = this.querySelector('[data-cube]');
      if (cube) cube.addEventListener('pointerdown', () => cube.classList.toggle('is-paused'));
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.validate(e), true);
        // El tema maneja el submit desde un ancestro: interceptamos el clic del botón antes que nadie.
        document.addEventListener(
          'click',
          (e) => {
            const btn = e.target && e.target.closest && e.target.closest('button');
            if (!btn) return;
            const isMain = btn.type === 'submit' && (this.form.contains(btn) || btn.form === this.form);
            const isSticky = btn.classList.contains('sticky-add-to-cart__button');
            if (isMain || isSticky) this.validate(e);
          },
          true
        );
        // Con fotos, el checkout dinámico ("Comprar ahora") no lleva archivos: lo ocultamos.
        if (this.required.cubo || this.required.instax) {
          this.form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach((el) => (el.hidden = true));
        }
      }
    }

    async onPick(input) {
      const file = input.files && input.files[0];
      const slot = input.closest('.bx-slot');
      if (!file) return this.clearSlot(slot);
      await this.setSlot(slot, input, file);
    }

    async onMulti(multi) {
      const files = Array.from(multi.files || []).filter((f) => f.type.startsWith('image/'));
      multi.value = '';
      const empties = Array.from(this.querySelectorAll('.bx-slot[data-slot="instax"]')).filter((s) => !s.classList.contains('is-filled'));
      for (let i = 0; i < Math.min(files.length, empties.length); i++) {
        const slot = empties[i];
        await this.setSlot(slot, slot.querySelector('.bx-slot__input'), files[i]);
      }
    }

    async setSlot(slot, input, file) {
      if (!file.type.startsWith('image/')) return this.error('Solo se aceptan fotos (JPG, PNG o HEIC).');
      slot.classList.add('is-busy');
      try {
        const compressed = await this.compress(file);
        try {
          const dt = new DataTransfer();
          dt.items.add(compressed);
          input.files = dt.files;
        } catch (_) {
          /* navegador sin DataTransfer: se sube el original */
        }
        const url = URL.createObjectURL(compressed);
        const img = slot.querySelector('.bx-slot__img');
        img.src = url;
        img.hidden = false;
        slot.querySelector('.bx-slot__remove').hidden = false;
        slot.classList.add('is-filled');
        this.paintCube(slot, url);
        this.error('');
      } catch (err) {
        this.error('No pudimos leer esa foto. Prueba con otra.');
      } finally {
        slot.classList.remove('is-busy');
        this.updateCounts();
      }
    }

    clearSlot(slot) {
      if (!slot) return;
      const input = slot.querySelector('.bx-slot__input');
      input.value = '';
      const img = slot.querySelector('.bx-slot__img');
      img.hidden = true;
      img.removeAttribute('src');
      slot.querySelector('.bx-slot__remove').hidden = true;
      slot.classList.remove('is-filled');
      this.paintCube(slot, null);
      this.updateCounts();
    }

    paintCube(slot, url) {
      if (slot.dataset.slot !== 'cubo') return;
      const face = this.querySelector(`.bx-cube__face[data-face="${slot.dataset.index}"]`);
      if (!face) return;
      if (url) {
        face.style.setProperty('--photo', `url("${url}")`);
        face.classList.add('has-photo');
      } else {
        face.style.removeProperty('--photo');
        face.classList.remove('has-photo');
      }
    }

    compress(file) {
      const max = this.maxSide;
      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(url);
          const scale = Math.min(1, max / Math.max(img.width, img.height));
          if (scale === 1 && file.size < 1.8 * 1024 * 1024 && /jpe?g|png/i.test(file.type)) return resolve(file);
          const canvas = document.createElement('canvas');
          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => {
              if (!blob) return reject(new Error('toBlob'));
              const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
              resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
            },
            'image/jpeg',
            0.86
          );
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          // HEIC u otro formato que el navegador no decodifica: se sube tal cual.
          resolve(file);
        };
        img.src = url;
      });
    }

    count(kind) {
      return this.querySelectorAll(`.bx-slot[data-slot="${kind}"].is-filled`).length;
    }

    updateCounts() {
      ['cubo', 'instax'].forEach((kind) => {
        const el = this.querySelector(`[data-count="${kind}"]`);
        if (!el) return;
        const n = this.count(kind);
        el.textContent = `${n} de ${this.required[kind]}`;
        el.classList.toggle('is-done', n >= this.required[kind]);
      });
    }

    updateChars(ta) {
      const el = this.querySelector('[data-chars="frase"]');
      if (el) el.textContent = `${ta.value.length}/${ta.maxLength}`;
    }

    validate(e) {
      const missing = [];
      if (this.required.cubo && this.count('cubo') < 4) missing.push(`faltan ${4 - this.count('cubo')} fotos del cubo`);
      if (this.required.instax && this.count('instax') < 10) missing.push(`faltan ${10 - this.count('instax')} fotos Instax`);
      if (!missing.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.error(`Para armar tu regalo ${missing.join(' y ')}.`);
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    error(msg) {
      const el = this.querySelector('[data-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = !msg;
    }
  }
  if (!customElements.get('bombox-personalizer')) customElements.define('bombox-personalizer', BomboxPersonalizer);
  } catch(e) { console.error(e); }
})();

})();
